import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { $api } from "../generated/client";
import type {ShopDto} from "../generated/schema.ts";
import {useMutation, useQueryClient} from "@tanstack/react-query";

export function useResetShippingboHooks(shop: ShopDto) {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();
  const mutation = $api.useMutation("post", "/shops/{shopId}/integrations/shippingbo/hooks/reset");
  const invalidateShippingBoHooks = useInvalidateShippingBoHooks({ shopId: shop.id });

  return useMutation({
    onSuccess: () => {
      invalidateShippingBoHooks();
      successNotification();
    },
    onError: () => {
      errorNotification();
    },
    mutationFn: async () => {
      return mutation.mutateAsync({ params: { path: { shopId: shop.id } } });
    },
  });
}

export const useInvalidateShippingBoHooks = ({ shopId }: { shopId: string }) => {
  const queryClient = useQueryClient();
  return () => {
    queryClient.invalidateQueries({
      queryKey: ["get", "/shops/{shopId}/integrations/shippingbo/hooks", { params: { path: { shopId } } }],
    });
  };
};